__turbopack_context__.v({
  "toggle_btn_avn": "pj19mG_toggle_btn_avn",
  "toggle_btn_sts": "pj19mG_toggle_btn_sts",
});
